module.exports = __webpack_public_path__ + "img/EU-startups.961d66c3.png";